module.exports = __webpack_public_path__ + "static/media/maf-18.d4934d31.png";